import { create } from "zustand";

/**
 * Single, minimal Zustand store for the shared rocket (hard rule: one store per
 * app). The flight is TIME MATH: launchAt comes from the server, the curve is the
 * shared crash formula, and every client renders the same rocket off its corrected
 * clock. This store mirrors /api/rocket/state + the clock offset.
 */

export interface RocketLast {
  roundId: number;
  crashPoint: number;
  survivors: number;
  riders: number;
  best: number;
}

export interface RocketState {
  serverNow: number;
  roundId: number;
  phase: "boarding" | "flying" | "landed";
  launchAt: number;
  boardedCount: number;
  meBoarded: boolean;
  /** null = still riding (or not boarded); 0 = rode it down; >0 = cashout ×100. */
  myResult: number | null;
  crashPoint: number | null;
  crashesAt: number | null;
  last: RocketLast | null;
}

interface RocketStore {
  state: RocketState | null;
  /** serverNow − Date.now() at fetch; corrected clock = Date.now() + offset. */
  clockOffset: number;
  /** Local optimistic cashout (mult ×100) so the UI locks instantly. */
  cashed: number | null;

  apply: (s: RocketState) => void;
  setCashed: (v: number) => void;
  clearCashed: () => void;
}

export const useRocketStore = create<RocketStore>((set) => ({
  state: null,
  clockOffset: 0,
  cashed: null,

  apply: (s) =>
    set((prev) => ({
      state: s,
      clockOffset: s.serverNow - Date.now(),
      // a new round clears the local cashout latch
      cashed: prev.state && prev.state.roundId !== s.roundId ? null : prev.cashed,
    })),
  setCashed: (v) => set({ cashed: v }),
  clearCashed: () => set({ cashed: null }),
}));
